// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"6f41f823","453":"9ad6e8af","455":"a3024b1d"}[chunkId] + ".chunk.js";
};